import { Injectable } from '@angular/core';
import { SaveFormActionHandlerService } from './save.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { incentiveProgram } from '../../../project/project.constants';
import { SweetAlertOptions } from 'sweetalert2';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class AddENTIdActionHandlerService extends SaveFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    public formDataService: FormDataService,
    public formShareService: FormShareService,
    public formStatusService: FormStatusService,
    public swalService: SwalService,
    public userContextService: UserContextService,
    public emailService: EmailService,
    public pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      formDataService,
      formShareService,
      formStatusService,
      swalService,
      userContextService,
      pubSubService,
      emailService,
      navService
    );
  }
  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      const swalOptions = <SweetAlertOptions>{};
      if (
        that.formShareService.currentIncentiveProgram ===
        incentiveProgram.film.code
      ) {
        swalOptions.inputValue =
          that.formShareService.filmProject.projectInfo['filmId'];
        swalOptions.title = 'Please assign a Film ID';
        swalOptions.type = 'success';
        swalOptions.inputPlaceholder = 'Please enter the FILM Id';
        swalOptions.confirmButtonText = 'Assign FILM Id';
        that.swalService
          .textarea(swalOptions, 'required', 'Please assign the Id')
          .then(id => {
            that.formShareService.filmProject.projectInfo['filmId'] = id;
            super.exec();
          })
          .catch(() => {});
      }
      if (
        that.formShareService.currentIncentiveProgram ===
        incentiveProgram.dm.code
      ) {
        swalOptions.inputValue =
          that.formShareService.digitalProject.projectInfo['digitalId'];
        swalOptions.title = 'Please assign a DM ID';
        swalOptions.type = 'success';
        swalOptions.inputPlaceholder = 'Please enter the DM Id';
        swalOptions.confirmButtonText = 'Assign DM Id';
        that.swalService
          .textarea(swalOptions, 'required', 'Please assign the Id')
          .then(id => {
            that.formShareService.digitalProject.projectInfo['digitalId'] = id;
            super.exec();
          })
          .catch(() => {});
      }
    });
  }
}
